import { all, call, put, takeLatest } from 'redux-saga/effects';

import { request } from '@app/services';
import { setToken } from '@app/modules/common';
import { prepareUserSessionSaga } from '../bootstrap';
import * as endpoints from './endpoints';
import {
  login,
  loginSuccess,
  loginFailed,
  forgotPassword,
  forgotPasswordSuccess,
  forgotPasswordFailed,
  setPassword,
  setPasswordSuccess,
  setPasswordFailed,
} from './slice';
import { Strings } from '@app/constants';

// ------------------------------------------------------

function* loginSaga(action: ReturnType<typeof login>): any {
  try {
    const { email, password } = action.payload;
    const { data } = yield call(request.post, endpoints.login, {
      username: email,
      password,
    });
    yield put(loginSuccess(data));
    yield put(setToken(data.accessToken));
    yield call(prepareUserSessionSaga);
  } catch (error) {
    yield put(loginFailed(error));
  }
}

function* forgotPasswordSaga(action: ReturnType<typeof forgotPassword>): any {
  try {
    const { email } = action.payload;

    yield call(request.post, endpoints.forgotPassword, {
      username: email,
    });
    yield put(forgotPasswordSuccess(Strings.auth.checkAPasswordLink));
  } catch (error) {
    yield put(forgotPasswordFailed(error));
  }
}
function* setPasswordSaga(action: ReturnType<typeof setPassword>): any {
  try {
    const { password, token } = action.payload;

    const { data } = yield call(request.post, endpoints.setPassword, {
      token,
      password,
    });
    yield put(setPasswordSuccess(data));
  } catch (error) {
    yield put(setPasswordFailed(error));
  }
}

function* authSagas() {
  yield all([
    takeLatest(login, loginSaga),
    takeLatest(forgotPassword, forgotPasswordSaga),
    takeLatest(setPassword, setPasswordSaga),
  ]);
}

export { authSagas };
